import styled from 'styled-components';
import { Navbar } from 'reactstrap';

export const PageNotFoundContainer = styled.div`
  text-align: left;
  .title {
    margin-top: 20%;
    color: red;
    font-size: 48px;
    font-weight: 300;
    line-height: 48px;
  }
  .sub-title {
    margin-top: 30px;
    font-size: 15px;
    font-weight: 400;
  }
`;

export const PageNotFoundNavBar = styled(Navbar)`
  padding: 0.3rem 0.3rem;
  max-height: 10vh;
  min-height: 62px;
  background-color: #101130;
  margin-bottom: 5%;
`;
